export const environment = {
	learningpaths: false,
	staging: false,
	rc: false,
	hotfix: false,
	production: true
};
